import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import KakaoMaps from '../../components/map/KaKaoMaps'
import { BoxShadow } from '../atom'
import HappyCrew from '../../assets/image/delivery/happy-crew.png'
import BaroGo from '../../assets/image/delivery/barogo.png'
import colors from '../../styles/colors'
import theme from '../../styles/theme'
import Loading from '../../components/atom/loading/Loading'

//utils
import { useAxios } from '../../utils/useAxios'
// globals
import * as constants from '../../globals/constants'

const DeliveryInfo = ({ deliveryStoreInfo, isDelivery }) => {
  const [activeTab, setActiveTab] = useState(0)
  const { fetchData, loading, data, error } = useAxios()

  // kakaoMaps api data props
  const [storePoint, setStorePoint] = useState({ latitude: '', longitude: '' })
  const [storePolygon, setStorePolygon] = useState(null)

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex)
  }

  const getDeliveryMaps = () => {
    fetchData(
      constants.API.DELIVERY_MAP, // url
      'GET', // method
      null, // body
      null, // params
    )
  }

  useEffect(() => {
    getDeliveryMaps()
  }, [])

  useEffect(() => {
    if (data) {
      setStorePolygon(data.responseData?.storePolygon)
      setStorePoint(data.responseData?.storePoint)
    }
  }, [data])

  return (
    <DeliveryWrap>
      <BoxShadow paddingVertical={24} paddingHorizontal={25}>
        <DeliveryBox>
          <div className="deliveryBox">
            <DeliveryTit>배달대행사 연동 업체</DeliveryTit>
            {isDelivery === 'Y' ? (
              <>
                <CrewImgBox>
                  {deliveryStoreInfo?.mappingDcList &&
                    deliveryStoreInfo?.mappingDcList.map((item, idx) => (
                      <button
                        type="button"
                        onClick={() => handleTabClick(idx)}
                        className={activeTab === idx ? 'active' : ''}
                      >
                        <DeliveryCrew
                          className={`tabButton ${
                            activeTab === idx ? 'active' : ''
                          }`}
                        >
                          <img src={item?.dcImage} alt="배달대행사" />
                        </DeliveryCrew>
                        <h4 className="crewName">{item?.dcName}</h4>
                      </button>
                    ))}

                  {/* <button
                    type="button"
                    onClick={() => handleTabClick(0)}
                    className={activeTab === 0 ? 'active' : ''}
                  >
                    <DeliveryCrew
                      className={`tabButton ${activeTab === 0 ? 'active' : ''}`}
                    >
                      <img
                        src={deliveryStoreInfo?.mappingDcList[0]?.dcImage}
                        alt="배달대행사"
                      />
                    </DeliveryCrew>
                    <h4 className="crewName">
                      {deliveryStoreInfo?.mappingDcList[0]?.dcName}
                    </h4>
                  </button>
                  {deliveryStoreInfo?.mappingDcList[1] && (
                    <button
                      type="button"
                      onClick={() => handleTabClick(1)}
                      className={activeTab === 1 ? 'active' : ''}
                    >
                      <DeliveryCrew
                        className={`tabButton ${
                          activeTab === 1 ? 'active' : ''
                        }`}
                      >
                        <img
                          src={deliveryStoreInfo?.mappingDcList[1]?.dcImage}
                          alt="배달대행사"
                        />
                      </DeliveryCrew>
                      <h4 className="crewName">
                        {deliveryStoreInfo?.mappingDcList[1]?.dcName}
                      </h4>
                    </button>
                  )} */}
                </CrewImgBox>
                <p className="deliveryRefer">
                  *배달대행사 연동 설정은 POS용 주문접수 프로그램에서 변경, 혹은
                  고객센터로 문의 부탁드립니다.
                </p>
              </>
            ) : (
              <p className="deliveryRefer">
                * 해피크루는 도보배달 서비스로, 해당 서비스 이용시 이륜배달
                대행사 연동이 필수입니다.
              </p>
            )}
          </div>
          {isDelivery === 'Y' && (
            <>
              <BoxLine />
              <div className="deliveryBox">
                <DeliveryTit>배달대행사 등록 정보</DeliveryTit>
                {deliveryStoreInfo?.mappingDcList &&
                  (activeTab === 0 || activeTab === 1) && (
                    <CrewInfoBox>
                      <div className="deliveryBtw">
                        <dt className="deliveryDt">지점명</dt>
                        <dd className="deliveryDd">
                          {deliveryStoreInfo.mappingDcList[activeTab]?.dcName}
                        </dd>
                      </div>
                      <div className="deliveryBtw">
                        <dt className="deliveryDt">가맹점명</dt>
                        <dd className="deliveryDd">
                          {
                            deliveryStoreInfo?.mappingDcList[activeTab]
                              ?.storeName
                          }
                        </dd>
                      </div>
                      <div className="deliveryBtw">
                        <dt className="deliveryDt">사업자번호</dt>
                        <dd className="deliveryDd">
                          {deliveryStoreInfo?.mappingDcList[activeTab]?.bizNo}
                        </dd>
                      </div>
                      <div className="deliveryBtw">
                        <dt className="deliveryDt">대표자명</dt>
                        <dd className="deliveryDd">
                          {
                            deliveryStoreInfo?.mappingDcList[activeTab]
                              ?.president
                          }
                        </dd>
                      </div>
                      <div className="deliveryBtw">
                        <dt className="deliveryDt">전화번호</dt>
                        <dd className="deliveryDd">
                          {deliveryStoreInfo?.mappingDcList[activeTab]?.tel}
                        </dd>
                      </div>
                      {/* <div className="deliveryBtw">
                        <dt className="deliveryDt">매장코드</dt>
                        <dd className="deliveryDd">
                          {
                            deliveryStoreInfo?.mappingDcList[activeTab]
                              ?.dcStoreCode
                          }
                        </dd>
                      </div> */}
                    </CrewInfoBox>
                  )}

                {/* {activeTab === 0 && (
                  <CrewInfoBox>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">지점명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo.mappingDcList[0]?.dcName}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">가맹점명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[0]?.storeName}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">사업자번호</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[0]?.bizNo}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">대표자명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[0]?.president}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">전화번호</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[0]?.tel}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">매장코드</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[0]?.dcStoreCode}
                      </dd>
                    </div>
                  </CrewInfoBox>
                )}
                {deliveryStoreInfo?.mappingDcList[1] && activeTab === 1 && (
                  <CrewInfoBox>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">지점명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo.mappingDcList[1]?.dcName}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">가맹점명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[1]?.storeName}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">사업자번호</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[1]?.bizNo}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">대표자명</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[1]?.president}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">전화번호</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[1]?.tel}
                      </dd>
                    </div>
                    <div className="deliveryBtw">
                      <dt className="deliveryDt">매장코드</dt>
                      <dd className="deliveryDd">
                        {deliveryStoreInfo?.mappingDcList[1]?.dcStoreCode}
                      </dd>
                    </div>
                  </CrewInfoBox>
                )} */}
              </div>
            </>
          )}
        </DeliveryBox>
      </BoxShadow>
      {loading ? (
        <Loading />
      ) : (
        <BoxShadow>
          <DeliveryTit>배달지역</DeliveryTit>
          <KakaoMaps storePolygon={storePolygon} storePoint={storePoint} />
        </BoxShadow>
      )}
    </DeliveryWrap>
  )
}

export default DeliveryInfo

const DeliveryWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  max-width: 768px;
  .tabButton.active {
    border: 3px solid ${colors.mainG};
  }
`

const DeliveryTit = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;
`

const DeliveryBox = styled.div`
  display: flex;
  flex-direction: row;
  .deliveryBox {
    width: 100%;
    @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
      width: 100%;
    }
  }
  .deliveryRefer {
    font-size: 14px;
    color: #a8a8a8;
    line-height: 1.5;
  }
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`
const BoxLine = styled.div`
  width: 1px;
  height: 290px;
  background-color: #f3f3f3;
  margin-right: 30px;
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    margin: 0;
    width: 100%;
    height: 1px;
    margin: 19px 0 27px;
  }
`

const CrewImgBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 58px;
  padding: 20px;
  align-items: center;
  .crewName {
    font-size: 18px;
    color: #000;
    margin-top: 22px;
  }
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    padding: 20px 30px 19px;
  }
`

const CrewInfoBox = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 15px;
  .deliveryBtw {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .deliveryDt {
    width: 75px;
    font-size: 16px;
    color: #a8a8a8;
    line-height: 1.5;
  }
  .deliveryDd {
    font-size: 16px;
    color: #000;
    line-height: 1.5;
  }
`
const DeliveryCrew = styled.div`
  width: 102px;
  height: 102px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-align: center;

  &:hover {
    border: 3px solid ${colors.mainG};
  }
  img {
    width: 100%;
    object-fit: cover;
  }

  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    width: 60px;
    height: 60px;
    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
    }
  }
`
